<template>
  <DxDropDownBox
    :value="selectedValue"
    :data-source="cultures"
    value-expr="uuid"
    display-expr="name"
    :placeholder="$t('works.cultures.select_fito_culture')"
    :show-clear-button="true"
    :disabled="disabled"
    :opened.sync="opened"
    :drop-down-options="dropDownOptions"
    @value-changed="onValueChanged"
  >
    <template #content>
      <DxDataGrid
        :data-source="cultures"
        key-expr="uuid"
        :selected-row-keys="selectedRowKeys"
        :hover-state-enabled="true"
        :column-auto-width="false"
        :show-borders="true"
        :remote-operations="false"
        height="100%"
        @selection-changed="onSelectionChanged"
      >
        <DxColumn data-field="name" :caption="$t('common.name')" :width="250" cell-template="nameCell" />
        <template #nameCell="{ data }">
          <span class="fito-culture-selector__text" :title="data.value">{{ data.value }}</span>
        </template>
        <DxColumn data-field="apia_code" :caption="$t('works.cultures.apia_code')" :width="250" />
        <DxColumn data-field="apia_name" :caption="$t('works.cultures.apia_name')" :width="250" cell-template="apiaNameCell" />
        <template #apiaNameCell="{ data }">
          <span class="fito-culture-selector__text" :title="data.value">{{ data.value }}</span>
        </template>
        <DxColumn data-field="is_active" :caption="$t('common.status')" data-type="boolean" :width="130" cell-template="statusCell">
          <DxLookup :data-source="statusOptions" value-expr="value" display-expr="text" />
        </DxColumn>
        <template #statusCell="{ data }">
          <span>{{ $t(data.value ? "common.active" : "common.inactive") }}</span>
        </template>
        <DxSelection mode="single" />
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />
        <DxSearchPanel :visible="true" :width="220" />
        <DxScrolling mode="virtual" />
        <DxPaging :enabled="false" />
      </DxDataGrid>
    </template>
  </DxDropDownBox>
</template>

<script>
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxColumn,
  DxLookup,
  DxSelection,
  DxFilterRow,
  DxHeaderFilter,
  DxSearchPanel,
  DxScrolling,
  DxPaging,
} from "devextreme-vue/data-grid";

export default {
  name: "FitoCultureSelector",
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxColumn,
    DxLookup,
    DxSelection,
    DxFilterRow,
    DxHeaderFilter,
    DxSearchPanel,
    DxScrolling,
    DxPaging,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    cultures: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
      selectedValue: this.value,
    };
  },
  watch: {
    value(value) {
      this.selectedValue = value;
    },
  },
  computed: {
    selectedRowKeys() {
      return this.selectedValue ? [this.selectedValue] : [];
    },
    statusOptions() {
      return [
        { value: true, text: this.$t("common.active") },
        { value: false, text: this.$t("common.inactive") },
      ];
    },
    dropDownOptions() {
      return {
        width: Math.min(820, window.innerWidth - 32),
        height: Math.min(480, window.innerHeight - 64),
        wrapperAttr: { class: "fito-culture-selector-popup" },
      };
    },
  },
  methods: {
    onSelectionChanged(event) {
      const selectedUuid = event.currentSelectedRowKeys?.[0];
      if (!selectedUuid) {
        return;
      }
      this.updateValue(selectedUuid);
      this.opened = false;
    },
    onValueChanged(event) {
      this.updateValue(event.value);
    },
    updateValue(value) {
      const selectedValue = value || null;
      if (selectedValue !== this.selectedValue) {
        this.selectedValue = selectedValue;
        this.$emit("input", selectedValue);
      }
    },
  },
};
</script>

<style scoped>
.fito-culture-selector__text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>